import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { BackendApiService } from '../../../../../services/backend-api.service';
import { FetchedDocument } from '../../documentation-chat';
import { Maintenance } from '../../../../maintenance/maintenance';
import { KeyValueListComponent } from '../../../../../components/key-value-list/key-value-list/key-value-list.component';
import { KeyValueListItemComponent } from '../../../../../components/key-value-list/key-value-list-item/key-value-list-item.component';
import { RouterService } from 'projects/phito-core/src/lib/services/router.service';
import { MAINTENANCE_ROUTES } from '../../../../maintenance/maintenance.routes';

@Component({
    selector: 'phito-maintenance-source',
    imports: [KeyValueListComponent, KeyValueListItemComponent],
    templateUrl: './maintenance-source.component.html',
    styleUrl: './maintenance-source.component.scss',
})
export class MaintenanceSourceComponent implements OnInit {
    private api = inject(BackendApiService);
    private routerService = inject(RouterService);

    @Input() sources: FetchedDocument[] = [];
    maintenances = signal<Maintenance[]>([]);

    ngOnInit(): void {
        for (const s of this.sources) {
            this.api.getOne('maintenances', s.id).subscribe({
                next: (response: Maintenance) => {
                    this.maintenances.update(arr => [...arr, response]);
                }
            });
        }
    }

    goToMaintenance(maintenance: Maintenance) {
        this.routerService.navNewTab(MAINTENANCE_ROUTES.detail, maintenance.id);
    }

}
